import { useState, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { TextField } from '@numbox/components';
import { Banner, Button } from '@numbox/components';
import { AuthModule, CLIENT_TYPE } from '@numbox/modules';

import { useAppSelector } from '~/effects/redux';
import { getAuthError } from '~/modules/auth';

import { Prompt } from '../../shared/Prompt';
import { PromptContent } from '../../shared/PromptContent';
import { PromptHeader } from '../../shared/PromptHeader';
import { LoginContext } from './LoginContext';
import {
  ROUTES,
  HAS_ENTERED_PASSWORD_KEY,
  getSafeDestination,
} from './constants';

export const EnterPassword = () => {
  const [password, setPassword] = useState('');
  const [authInProgress, setAuthInProgress] = useState(false);
  const authenticationError = useAppSelector(state => getAuthError(state));
  const dispatch = useDispatch();
  const history = useHistory();
  const { email, desiredDestination } = useContext(LoginContext);

  const isValid = password.length >= 4;
  const onSubmit = () => {
    setAuthInProgress(true);
    dispatch(
      AuthModule.auth.request(
        {
          email,
          password,
          clientType: CLIENT_TYPE,
          support_one_time_password: true,
        },
        {
          email,
          onSuccess: () => {
            history.push(getSafeDestination(desiredDestination));
            localStorage.setItem(HAS_ENTERED_PASSWORD_KEY, 'true');
          },
          onFailure: error => {
            if (error?.response?.status === 303) {
              history.push(error?.response?.data);
              return;
            }
            setAuthInProgress(false);
          },
        },
      ),
    );
  };

  return (
    <Prompt data-cy="login-form" variant="auth">
      <PromptHeader
        logoType="icon"
        title="What's your password?"
        subtitle={
          <span>
            Enter the <b>password</b> for your account <b>{email}</b>.
          </span>
        }
      />

      <Banner color="error" visible={Boolean(authenticationError)}>
        {authenticationError}
      </Banner>
      <PromptContent>
        <TextField
          data-cy="login-password"
          id="login-password"
          name="password"
          type="password"
          placeholder="Password"
          label="Password"
          autoComplete="current-password"
          autoFocus
          value={password}
          onChange={({ target: { value } }) => setPassword(value)}
          onKeyDown={event => {
            if (event.keyCode === 13) {
              event.preventDefault();
              event.stopPropagation();
              if (isValid) {
                onSubmit();
              }
            }
          }}
        />

        <Button
          isPrimary
          data-cy="login-btn"
          disabled={!isValid}
          onClick={onSubmit}
          inProgress={authInProgress}
        >
          Sign in
        </Button>
        <Button
          data-cy="email-button"
          onClick={() => {
            localStorage.removeItem(HAS_ENTERED_PASSWORD_KEY);
            dispatch(
              // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
              AuthModule.requestMagicLink.request({
                email,
                token_type: 'MAGIC_LINK',
              }),
            );
            history.push(`.${ROUTES.CHECK_EMAIL}`);
          }}
        >
          Don&apos;t know my password
        </Button>
      </PromptContent>
    </Prompt>
  );
};
